import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const VispunkSection = () => {
  return (
    <section className="py-16 bg-slate-50 dark:bg-slate-900">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">Vispunk</h2>
            <p className="max-w-[900px] text-slate-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-slate-400">
              Uma plataforma inovadora para criação de conteúdo visual com IA
            </p>
          </div>
        </div>
        <div className="mx-auto grid max-w-5xl items-center gap-6 py-12 lg:grid-cols-2 lg:gap-12">
          <div className="flex flex-col justify-center space-y-4">
            <div className="space-y-2">
              <h3 className="text-2xl font-bold tracking-tighter sm:text-3xl">
                Transforme suas ideias em arte visual
              </h3>
              <p className="max-w-[600px] text-slate-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-slate-400">
                O Vispunk utiliza tecnologia de ponta em inteligência artificial para transformar descrições textuais em imagens impressionantes.
              </p>
            </div>
            <div className="flex flex-col gap-2 min-[400px]:flex-row">
              <Button className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-8 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" onClick={() => window.open('https://vispunk.com/', '_blank')}>
                Explorar Vispunk
              </Button>
              <Button
                variant="outline"
                className="inline-flex h-10 items-center justify-center rounded-md border border-input bg-background px-8 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
                onClick={() => window.open('https://vispunk.com/', '_blank')}
              >
                Saiba mais
              </Button>
            </div>
          </div>
          <div className="mx-auto w-full max-w-[500px] rounded-lg border bg-background p-2 shadow-xl">
            <Card>
              <CardContent className="p-6">
                <div className="aspect-video overflow-hidden rounded-lg bg-slate-100 dark:bg-slate-800">
                  <img
                    alt="Vispunk Demo"
                    className="object-cover w-full h-full"
                    src="https://images.unsplash.com/photo-1655720031554-a929595ffad7?q=80&w=1000&auto=format&fit=crop"
                    width={500}
                    height={280}
                  />
                </div>
                <div className="mt-4 grid gap-2">
                  <h4 className="font-semibold">Geração de imagens com IA</h4>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    Crie ilustrações, arte conceitual, designs e muito mais com apenas algumas palavras.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-8">
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">Fácil de usar</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Interface intuitiva que permite criar imagens impressionantes sem conhecimento técnico.
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">Alta qualidade</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Imagens de alta resolução e qualidade profissional para diversos usos.
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">Personalização avançada</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Controle detalhado sobre o estilo, composição e elementos da imagem gerada.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default VispunkSection;